<template>
  <div class="help-doc-detail">
    <div class="doc-detail">
      <div class="detail-form-box" style="width:80%">
        <el-form :model="form" label-position="top">
          <el-form-item label="标题">
            <el-input size="small" v-model="form.title" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="类型" >
                <el-select v-model="form.Mtype" @change="onTabClass" placeholder="请选择"  style="margin-bottom:15px;width:100%;">
                  <el-option
                    v-for="item in docType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
          <el-form-item label="文档分类">
            <el-cascader
              size="small"
              ref="typeCascader"
              v-model="form.TypeCode"
              :options="typeList"
              :props="{ checkStrictly: true ,emitPath:false,label:'menuName',value:'id' }"
              clearable
              style="margin-bottom:15px;width:300px"
            ></el-cascader>
          </el-form-item>
          <div style="width:100%; height:340px" id="summernote" v-model="content"></div>
        </el-form>
      </div>
      <div class="form-foot">
        <div></div>
        <div style="padding-right:146px;">
          <el-button @click="onClose">返回</el-button>
          <el-button style="color:#fff" type="primary" @click="onSave">确 定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentView from "@/components/ContentView";
import apiPub from "@/api/public";
import $ from "jquery";
var flags=true;
export default {
  name: "enterprise",
  data() {
    return {
      typeList: [],
      richContent: "",
      content: "",
      urlData: {},
      searchVal: "",
      options: [],
      dialogFormVisible: false,
      docType:[
         {label:"尚匠云后台",value:0},
         {label:"尚匠云小程序",value:1}
      ],
      form: {
        title: "",
        TypeCode: "",
        Mtype:0,
        Morderby: "0",
        content: "",
      },
      input: "",
      win: false,
      value: "",
      timesRun: 0,
    };
  },
  components: {
    ContentView,
  },
  created() {
    this.urlData = this.$router.currentRoute.query;
    if (this.urlData.id) {
      this.load();
    }

    this.getTypeList();
  },
  mounted() {
    $("#summernote").summernote({
      lang: "zh-CN",
      placeholder: "请输入内容",
      height: 340,
      width: "100%",
      htmlMode: true,
      toolbar: [
        ["style", ["bold", "italic", "underline", "clear"]],
        ["fontsize", ["fontsize"]],
        ["fontname", ["fontname"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph", "height"]],
        ["insert", ["link", "picture"]],
        ["mybutton", ["myVideo"]],
      ],
      fontSizes: ["8", "9", "10", "11", "12", "14", "18", "24", "36"],
      fontNames: [
        "Arial",
        "Arial Black",
        "Comic Sans MS",
        "Courier New",
        "Helvetica Neue",
        "Helvetica",
        "Impact",
        "Lucida Grande",
        "Tahoma",
        "Times New Roman",
        "Verdana",
      ],
      buttons: {
        myVideo: "",
      },
      callbacks: {
        onSubmit: function () {
          vm.richContent = $("#summernote").summernote("code");
        },
        onPaste: function (ne) {
          // var bufferText = (
          //   (ne.originalEvent || ne).clipboardData || window.clipboardData
          // ).getData("Text/plain");
          // ne.preventDefault ? ne.preventDefault() : (ne.returnValue = false);
       
          // setTimeout(function () {
          //   document.execCommand("insertText", false, bufferText);
          // }, 10);
        },
      },
    });
  },
  methods: {
    //---------------查询区域--------begin-----------
    handleMarkdownChange() {},
    imgDel() {},
    imgAdd(i, file) {
      console.log(file);
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        console.log("file 转 base64结果：" + reader.result);
        const markdown = this.$refs.markdownEditor;
        markdown.$img2Url(i, reader.result);
        // this.iconBase64 = reader.result
      };
    },
    handleEditorSave() {},
    load() {
      var that = this;
      var obj = {
        url: apiPub.GetHelpMenuInfo,
        data: {
          ID: this.urlData.id,
        },
      };
      $http.request(obj, false, function (res) {
        // console.log(res);
        try{
          var content=decodeURIComponent(res.data.msg);
        }catch(err){
          var content=res.data.msg;
        }
        
        console.log(content)
        if (res.code == 200) {
          that.form = {
            id: res.data.id,
            title: res.data.title,
            TypeCode: res.data.mtype,
            Mtype:res.dataRemark.mtype,
            Morderby: res.data.morderby,
            content: content,
          };
          // dataRemark
          
          that.$emit("refresh",res.dataRemark)
          $("#summernote").summernote("code", content);
          that.content = content;
          that.getTypeList();
        }
      });
    },
    onTabClass(){
      this.getTypeList();
    },
    getTypeList() {
      var that = this;
      var SearchText = this.searchVal || "";
      var obj = {
        url: apiPub.HelpAllMenu,
        data: {
          Mtype:this.form.Mtype
        },
      };
      $http.request(obj, false, function (res) {
        // console.log(res)
        that.fordata(res.data);
        that.typeList = res.data;
      });
    },
    fordata(data) {
      const that = this;
      data.forEach((el) => {
        if (el.children && el.children.length > 0) {
          console.log(el.children);
          that.fordata(el.children);
          return;
        } else {
          console.log(el);
          el.children = null;
        }
      });
      return data;
    },
    // GetNoticeId
    //---------------业务区域--------end-----------
    onClose() {
      this.$router.back(-1);
      //   this.$router.push({ name: 'enterprise'});
    },
    onSave() {
      if(flags==false){
        return;
      }
     
      // console.log($('#summernote').summernote('code'))
      var userinfo = JSON.parse(localStorage.getItem("userinfo"));
      var that = this;
      var content = $("#summernote").summernote("code");
      //   console.log(this.content)
      if (this.form.title == "") {
        that.$message({
          message: "请输入文档分类",
          type: "none",
        });
        return;
      }
      if (this.form.TypeCode == "") {
        that.$message({
          message: "亲选择文档分类",
          type: "none",
        });
        return;
      }
      if (content == "") {
        that.$message({
          message: "请输入文档内容",
          type: "none",
        });
        return;
      }
      flags=false;
      // content
      
      var obj = {
        url: apiPub.AddHelpInfo,
        data: {
          Msg: encodeURIComponent(content),
          Mtype: this.form.TypeCode,
          Title: this.form.title,
          Morderby: this.form.Morderby,
          UserID: userinfo.id,
        },
      };
      if (this.form.id) {
        obj.url = apiPub.UpdateHelpMenuInfo;
        obj.data.ID = this.form.id;
      }
      $http.request(obj, false, function (res) {
        // console.log(res)
        flags=true;
        that.$message({
          message: "保存成功",
          type: "success",
        });
        setTimeout(function(){
          that.onClose()
        },1000)
      });
    },
    //---------------表格操作--------begin-----------

    /// -----------------------分页--begin-----------------------------
    /// -----------------------分页--end-------------------------------
  },
};
</script>
<style scoped>
.enterprise {
  /* padding: 20px; */
  background: #fff;
}
.org-logo {
  width: 40px;
  height: 40px;
}
.enter-input {
  width: 200px;
}
.enter-input + .enter-input {
  margin-left: 15px;
}
.el-form-item {
  margin-bottom: 0px;
}
.help-doc-detail {
  padding: 15px;
}
.doc-detail {
  background-color: #fff;
}
.form-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
}
.help-doc-detail /deep/ .sj-operate-wrapper {
  display: none;
}
.el-form-item /deep/ .el-form-item__label {
  /* line-height: 30px; */
  margin: 0;
  padding: 0;
}
#kt_scrolltop {
  display: none;
}
</style>
